import { CURRENCY } from './constants/currency';

// Mapping for fast lookups
const CURRENCY_MAP = {
    [CURRENCY.GOLD_DOLLAR_ID]: CURRENCY.GOLD_DOLLAR,
    [CURRENCY.SILVER_DOLLAR_ID]: CURRENCY.SILVER_DOLLAR,
    [CURRENCY.FIAT_DOLLAR_ID]: CURRENCY.FIAT_DOLLAR,
    [CURRENCY.GOLD_BACK_ID]: CURRENCY.GOLD_BACK,
};

const CURRENCY_NAME_TO_ID_MAP = {
    [CURRENCY.GOLD_DOLLAR]: CURRENCY.GOLD_DOLLAR_ID,
    [CURRENCY.SILVER_DOLLAR]: CURRENCY.SILVER_DOLLAR_ID,
    [CURRENCY.GOLD_BACK]: CURRENCY.GOLD_BACK_ID,
    [CURRENCY.FIAT_DOLLAR]: CURRENCY.FIAT_DOLLAR_ID,
}

export const getAssetNameById = (assetTypeId) => CURRENCY_MAP[assetTypeId] ?? '';
export const getAssetIdByName = (assetName) => CURRENCY_NAME_TO_ID_MAP[assetName] ?? null;
export const isFiatDollar = assetName => assetName === CURRENCY.FIAT_DOLLAR;
export const isSilverDollar = assetName => assetName === CURRENCY.SILVER_DOLLAR;
export const isGoldBack = assetName => assetName === CURRENCY.GOLD_BACK;